// extracted by mini-css-extract-plugin
export var backdropBlur = "_kd-0";
export var contentCard = "_kd-5";
export var frame = "_kd-2";
export var image = "_kd-4";
export var imagePane = "_kd-3";
export var modal = "_kd-1";